module.exports = __webpack_public_path__ + "media/printed-materials/image026-b006adfd.jpg";